import { Divider } from "@mui/material";
import GSName from "./components/GSName";
import GSLanguage from "./components/GSLanguage";
import GSColors from "./components/GSColors";
import GSComponents from "./components/GSComponents";
import CSLanguage from "../componentSettings/components/CSLanguage";
import GSGaps from "./components/GSGaps";
import GSAttributes from "./components/GSAttributes";

function GlobalSettings({
  pagename,
  setPagename,
  createEnabled,
  addComponent,
  colorFont,
  colorBackground,
  gaps,
  changeGlobalColorFont,
  changeGlobalColorBackground,
  changeGap,
  openLanguagesDetail,
  openAttributesDetail,
  selectedLanguage,
  setSelectedLanguage,
  copyAll,
}) {
  /**
   * ***********************************************
   * render
   * ***********************************************
   */

  return (
    <div>
      <GSName
        pagename={pagename}
        setPagename={setPagename}
        createEnabled={createEnabled}
      />
      <Divider />
      <GSAttributes openAttributesDetail={openAttributesDetail} />
      <Divider />
      <GSLanguage
        createEnabled={createEnabled}
        openLanguagesDetail={openLanguagesDetail}
      />
      <CSLanguage
        createEnabled={createEnabled}
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
        copyAll={copyAll}
      />
      <Divider />
      <GSColors
        colorFont={colorFont}
        colorBackground={colorBackground}
        changeGlobalColorFont={changeGlobalColorFont}
        changeGlobalColorBackground={changeGlobalColorBackground}
      />
      <GSGaps gaps={gaps} changeGap={changeGap} />
      <Divider />
      <GSComponents addComponent={addComponent} />
    </div>
  );
}

export default GlobalSettings;